function convertDateToLocalString(dateS) {
    if (!dateS) {
        return ''
    }
    return new Date(dateS).toLocaleDateString('ar-MA', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
}

export default convertDateToLocalString